module.exports = __webpack_public_path__ + "static/media/artunity-mockup-3.6dfaa070.jpg";